import { render } from "./PermissionIndex.vue?vue&type=template&id=7e3a7920&scoped=true"
import script from "./PermissionIndex.vue?vue&type=script&lang=js"
export * from "./PermissionIndex.vue?vue&type=script&lang=js"

import "./PermissionIndex.vue?vue&type=style&index=0&id=7e3a7920&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e3a7920"]])

export default __exports__